import React, { useCallback, useState } from 'react';
import {
  Buttons,
  Content,
  Icon,
  LastIcon,
  Left,
  Maincontent,
  ProjectTitle,
  Projectname,
  Right,
  Taskbutton
} from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import ButtonV2 from '../button/buttonV2';
import { useHistory } from 'react-router-dom';
import ModalCustom from '../models/modal';
import { useSelector, useDispatch } from 'react-redux';
import { saveProjectTemplateDetails } from '../../services/settingServices';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { RootReducerInterface } from '../../interfaces/RootReducerInterface';
import { PROJECT_ANALYTICS } from '../../global/analyticsConstants';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { convertProjectTemplateModelToInterface } from '../../mobx/common';
import CreateTaskModalV2 from '../models/createTaskModal/createTaskModalV2';
import { useMobileDevice } from '../../global/useMobile';
import ResponsiveHeader from '../../component/responsiveHeader/header';
import { BUTTON_TYPE } from '../../global/constants';
interface Props {
  isSettingPage?: boolean;
  loading?: boolean;
}
function TemplateHeader(props: Props) {
  const { isSettingPage = false, loading } = props;
  //States
  const [isModalOpen, setIsModalOpen] = useState(false);
  //use selector state variables
  const settingsSelector = useSelector((state: RootReducerInterface) => state.settings);
  const { loading: settingLoading } = settingsSelector;
  //Mobx store variables
  const { projectTemplateStore, taskStore } = rootStore;
  const { currentProjectTemplate } = projectTemplateStore;
  const { createTaskInput } = taskStore;
  //Other variable
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useMobileDevice();

  const handleOnClick = useCallback(async () => {
    if (currentProjectTemplate?.id) {
      createTaskInput?.setProject(currentProjectTemplate?.id, true);
      createTaskInput?.setPriority(currentProjectTemplate?.priority?.default || 0);
      createTaskInput?.setGroupId(currentProjectTemplate?.taskGroups?.[0]?.id || '');
      setIsModalOpen(true);
    }
  }, [
    createTaskInput,
    currentProjectTemplate?.id,
    currentProjectTemplate?.priority?.default,
    currentProjectTemplate?.taskGroups
  ]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const onClickTasks = useCallback(() => {
    if (currentProjectTemplate?.id) history.push(`/settings/templates/${currentProjectTemplate?.id}`);
  }, [history, currentProjectTemplate]);

  const onClickSettings = useCallback(() => {
    if (currentProjectTemplate?.id) history.push(`/settings/templates/${currentProjectTemplate?.id}?tab=setting`);
  }, [history, currentProjectTemplate]);

  const onClickSave = useCallback(async () => {
    if (currentProjectTemplate) {
      const cloneDetails = convertProjectTemplateModelToInterface(currentProjectTemplate);
      trackAnalyticActivity(PROJECT_ANALYTICS.TEMPLATE_DATA_UPDATED);
      await dispatch(saveProjectTemplateDetails(cloneDetails));
      currentProjectTemplate?.setUpdated(false);
    }
  }, [dispatch, currentProjectTemplate]);

  const renderButtonBlocks = () => {
    return (
      <Buttons>
        <Taskbutton isActive={!isSettingPage} onClick={onClickTasks}>
          Tasks
        </Taskbutton>
        <Taskbutton isActive={isSettingPage} onClick={onClickSettings}>
          Settings
        </Taskbutton>
      </Buttons>
    );
  };

  return (
    <>
      {!isMobile ? (
        <Maincontent>
          <Content>
            <Left>
              <Projectname>
                <Icon onClick={() => history.push('/settings/templates')}>
                  <SVGIcon
                    name='report-left-arrow-icon'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    className='arrow-icon'
                  />
                </Icon>
                <ProjectTitle>{currentProjectTemplate?.name || ''}</ProjectTitle>
              </Projectname>
              {renderButtonBlocks()}
            </Left>
            <Right>
              {!isSettingPage && (
                <LastIcon disabled={loading || settingLoading} onClick={handleOnClick}>
                  <SVGIcon name='task-plus-icon' width='32' height='33' viewBox='0 0 32 33' className='circle' />
                </LastIcon>
              )}
              <ButtonV2
                title='Save Template'
                variant={BUTTON_TYPE.PRIMARY}
                onClick={onClickSave}
                disabled={loading || settingLoading}
              />
            </Right>
          </Content>
        </Maincontent>
      ) : (
        <>
          <ResponsiveHeader Title={currentProjectTemplate?.name || ''} />
          {renderButtonBlocks()}
        </>
      )}
      <ModalCustom open={isModalOpen} onClose={handleCloseModal}>
        <CreateTaskModalV2 onCancel={handleCloseModal} isTemplateProject={true} />
      </ModalCustom>
    </>
  );
}

export default observer(TemplateHeader);
